// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1fE2w","file":"styles_file__3v013"};